import { render, staticRenderFns } from "./work-order-view-logs.vue?vue&type=template&id=ff3245c4&scoped=true"
import script from "./work-order-view-logs.vue?vue&type=script&lang=js"
export * from "./work-order-view-logs.vue?vue&type=script&lang=js"
import style0 from "./work-order-view-logs.vue?vue&type=style&index=0&id=ff3245c4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff3245c4",
  null
  
)

export default component.exports